<template>
  <v-layout>
    <v-navigation-drawer :width="400" class="helpDrawer" v-model="helpbar.isVisible.value"
      :location="'right'" temporary app>
      <div class="helpDrawerContent d-flex flex-column justify-space-between">
        <div>
          <div class="helpDrawerTitle d-flex align-center justify-space-between px-4 py-4">
            <p>Insights - Rubeus {{ helpbar.title }}</p>
            <v-btn icon density="compact" size="default" variant="text" @click="closeHelpbar">
                    <v-icon size="default">mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="px-4 pt-4 pb-6">
            <v-text-field v-model="searchTerm" class="primary-input" placeholder="Pesquisar" color="primary-60"
              density="compact" prepend-inner-icon="mdi-magnify" clearable hide-details></v-text-field>
          </div>
        </div>


        <div class="helpDrawerArticles">
          <v-list v-if="filteredArticles.length > 0">
            <div v-for="article in filteredArticles" :key="article.id">
              <v-list-item class="selectedArticleItem d-flex justify-start" :title="article.title"
                @click="openArticle(article.html_url)"></v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list>
            <div v-else class="u-empty-state">
                  <div v-if="searchTerm" class="pa-8">
                    <h3>Nenhum artigo encontrado para o termo <br> "{{ searchTerm }}".</h3>
                    <p>Experimente redefinir sua pesquisa.</p>
                  </div>
                  <div v-else class="pa-8">
                    <h3>Nenhum artigo disponível.</h3>
                    <p>Artigos aparecerão aqui quando forem cadastrados.</p>
                  </div>
                </div>
        </div>
        <v-divider></v-divider>
        <div class="helpDrawerFooter pa-3 d-flex flex-column align-start ga-6">
          <p>Ainda com dúvidas?</p>
          <div class="d-flex ga-2">
            <HelpCard text="Base de conhecimento"
              link="https://crmrubeus.zendesk.com/hc/pt-br/categories/360000249231-Base-de-conhecimento"
              :icon="require('@/ai_studio/assets/icons/base-conhecimentos.svg')" />
            <HelpCard text="Comunidade" link="https://crmrubeus.zendesk.com/hc/pt-br/community/topics"
              :icon="require('@/ai_studio/assets/icons/base-conhecimentos.svg')" />
            <HelpCard text="Novidades" link="https://crmrubeus.zendesk.com/hc/pt-br/categories/360000306971/"
              :icon="require('@/ai_studio/assets/icons/base-conhecimentos.svg')" />
          </div>
        </div>
        <v-divider></v-divider>
      </div>
    </v-navigation-drawer>
  </v-layout>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { helpbar } from "@/ai_studio/utils/helpbar"
import HelpCard from "@/assistents/components/HelpCard.vue"


const route = useRoute()

const searchTerm = ref('')

const filteredArticles = computed(() => {
  if (!searchTerm.value) {
    return helpbar.articles.value
  }
  return helpbar.articles.value.filter(article =>
    article.title.toLowerCase().includes(searchTerm.value.toLowerCase())
  )
})

const openArticle = (link) => {
  window.open(link, '_blank')
}

const closeHelpbar = () => {
  helpbar.close()
}

watch(() => route.path, () => {
  helpbar.clearArticles()
})
</script>

<style scoped>
.v-navigation-drawer__scrim {
  position: fixed !important;
}

.selectedArticleItem {
  padding: 8px 16px !important;
}

.helpDrawer {
  font-family: Roboto;
  background: #FFF;
}

.helpDrawerContent {
  height: 100%;
}


.helpDrawerTitle {
  background-color: rgb(var(--v-theme-neutral-95));
}

.helpDrawerTitle p {
  color: rgb(var(--v-theme-neutral-35));
  font-size: 16px;
  font-weight: 500;
  line-height: 2.5;
}

.helpDrawerArticles {
  overflow-y: auto;
  height: 100%;

}

.helpDrawerFooter {
  height: 172px;
}

.primary-input:deep(.v-field__input) {
  background: rgb(var(--v-theme-neutral-98));
  font-family: Roboto;
  width: 100% !important;
  padding: 16px 12px;
}

.primary-input:deep(.v-field .v-field__overlay) {
  opacity: 1;
  background-color: rgb(var(--v-theme-neutral-98)) !important;
}

.primary-input:deep(.v-field .v-field__append-inner),
.primary-input:deep(.v-field .v-field__prepend-inner) {
  background-color: rgb(var(--v-theme-neutral-98)) !important;
}

.primary-input:deep(.v-field__input) {
  background: rgb(var(--v-theme-neutral-98));
  font-family: Roboto;
  width: 100% !important;
}

.primary-input:deep(.v-field-label) {
  font-family: Roboto;
}
</style>
